"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = defineProp;

var _defs = _interopRequireDefault(require("./defs"));

var _set2 = _interopRequireDefault(require("../set"));

var _seempleerror = _interopRequireDefault(require("../_helpers/seempleerror"));

function errorAccessor() {
  throw (0, _seempleerror["default"])('common:use_magic_props');
} // the function defines needed descriptor for given property


function defineProp(object, key, noAccessor) {
  var def = _defs["default"].get(object); // if no object definition do nothing


  if (!def) {
    return null;
  }

  if (!def.props[key]) {
    var propDef = def.props[key] = {
      value: object[key],
      mediator: null,
      bindings: null
    };
    var getter;
    var setter; // make possible to throw an error on get and on set if sandbox (for all objects)
    // or container (for Seemple.Array instances) are used

    if (key === 'sandbox' || object.isSeempleArray && key === 'container') {
      getter = setter = errorAccessor;
    }

    if (!noAccessor) {
      Object.defineProperty(object, key, {
        configurable: true,
        enumerable: true,
        get: function get() {
          return getter ? getter() : propDef.value;
        },
        set: function set(v) {
          return setter ? setter() : (0, _set2["default"])(object, key, v, {
            fromSetter: true
          });
        }
      });
    }
  }

  return def.props[key];
}
//# sourceMappingURL=defineprop.js.map